/* CSL · LED field — the animated red LED grid from the Black Friday landing, drawn inside a box.
   Markup: <div data-csl-leds-box> <canvas data-csl-leds></canvas> … <div data-csl-leds-clear>content</div> </div>
   LEDs light up only around the edges: none behind the [data-csl-leds-clear] element, with a soft fade towards it.
   data-lit = % of LEDs on (default 45), data-strength = brightness and size, 10–100 (default 100).
   Without a [data-csl-leds-clear] element the LEDs fill the whole box.
   Runs only while the box is on screen; a single still frame with reduced motion. */
(function () {
  if (window.__cslLeds) return;
  window.__cslLeds = true;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // one glowing LED, drawn once and stamped
  const S = 48, sprite = document.createElement('canvas');
  sprite.width = sprite.height = S;
  {
    const sg = sprite.getContext('2d');
    const g = sg.createRadialGradient(S / 2, S / 2, 0, S / 2, S / 2, S / 2);
    g.addColorStop(0, 'rgba(255,232,232,1)');
    g.addColorStop(0.09, 'rgba(255,70,86,.95)');
    g.addColorStop(0.26, 'rgba(255,42,61,.38)');
    g.addColorStop(0.55, 'rgba(255,42,61,.08)');
    g.addColorStop(1, 'rgba(255,42,61,0)');
    sg.fillStyle = g; sg.fillRect(0, 0, S, S);
  }
  // smooth value noise
  const P = new Uint8Array(512);
  { const p = [...Array(256).keys()]; for (let i = 255; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [p[i], p[j]] = [p[j], p[i]]; } for (let i = 0; i < 512; i++) P[i] = p[i & 255]; }
  const fade = (t) => t * t * (3 - 2 * t), lerp = (a, b, t) => a + (b - a) * t;
  const hash = (x, y, z) => P[(P[(P[x & 255] + y) & 255] + z) & 255] / 255;
  const noise = (x, y, z) => {
    const xi = Math.floor(x), yi = Math.floor(y), zi = Math.floor(z);
    const xf = fade(x - xi), yf = fade(y - yi), zf = fade(z - zi);
    const c = (a, b, d) => hash(xi + a, yi + b, zi + d);
    return lerp(lerp(lerp(c(0, 0, 0), c(1, 0, 0), xf), lerp(c(0, 1, 0), c(1, 1, 0), xf), yf),
      lerp(lerp(c(0, 0, 1), c(1, 0, 1), xf), lerp(c(0, 1, 1), c(1, 1, 1), xf), yf), zf);
  };

  const init = (box) => {
    if (box.__leds) return; box.__leds = true;
    const cv = box.querySelector('[data-csl-leds]'), clear = box.querySelector('[data-csl-leds-clear]');
    if (!cv || !cv.getContext) return;
    const ctx = cv.getContext('2d');
    const lit = Math.min(0.9, Math.max(0.05, (parseFloat(box.dataset.lit) || 45) / 100));
    const strength = Math.min(1, Math.max(0.1, (parseFloat(box.dataset.strength) || 100) / 100));
    let W = 0, H = 0, gap = 20, dots = [], alpha = new Float32Array(0), raf = 0, visible = false, lastT = 0, phase = 0, zphase = 0;
    const lowPower = innerWidth < 700 || (navigator.hardwareConcurrency || 8) <= 4;
    const layout = () => {
      const r = box.getBoundingClientRect();
      W = r.width; H = r.height;
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      gap = W < 700 ? 16 : 20;
      // clear zone = the content, slightly enlarged; LEDs fade in over `soft` px around it
      const c = clear ? clear.getBoundingClientRect() : null;
      const pad = W < 700 ? 6 : 22, soft = W < 700 ? 34 : 90;
      const cx0 = c ? c.left - r.left - pad : W, cx1 = c ? c.right - r.left + pad : 0;
      const cy0 = c ? c.top - r.top - pad : H, cy1 = c ? c.bottom - r.top + pad : 0;
      dots = [];
      for (let y = gap / 2; y < H; y += gap) for (let x = gap / 2; x < W; x += gap) {
        const dx = Math.max(cx0 - x, 0, x - cx1), dy = Math.max(cy0 - y, 0, y - cy1);
        const out = Math.min(1, Math.hypot(dx, dy) / soft);
        const m = out * out * (3 - 2 * out);
        dots.push({ x, y, m, r: Math.random(), ph: Math.random() * 6.283, s: 0.8 + Math.random() * 0.4 });
      }
      alpha = new Float32Array(dots.length);
    };
    const draw = (time, dt) => {
      if (!reduceMotion) { phase += 0.0016 * dt; zphase += 0.0022 * dt; }
      const f = 1 / 260;
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = 'rgba(255,255,255,0.05)';
      for (const d of dots) if (d.m > 0.05) ctx.fillRect(d.x - 0.5, d.y - 0.5, 1, 1);
      ctx.globalCompositeOperation = 'lighter';
      const thr = 1 - lit, sz0 = gap * (1.2 + 0.7 * strength), k0 = reduceMotion ? 1 : Math.min(1, 0.2 * dt);
      for (let i = 0; i < dots.length; i++) {
        const d = dots[i];
        if (d.m < 0.02) continue;
        const n = noise(d.x * f, d.y * f + phase, zphase) * 0.65 + noise(d.x * f * 2.3 + 17, d.y * f * 2.3 - phase * 1.7, zphase * 1.4 + 5) * 0.35;
        const v = n * 0.85 + d.r * 0.15;
        let a = (v - thr) / 0.06 + 0.5;
        a = a < 0 ? 0 : a > 1 ? 1 : a;
        alpha[i] += (a - alpha[i]) * k0;
        let k = alpha[i] * d.m * strength;
        if (k < 0.02) continue;
        if (!reduceMotion) k *= 0.8 + 0.2 * Math.sin(time * 0.0012 + d.ph);
        const sz = sz0 * d.s;
        // soft halo first, then the LED itself
        const hs = sz * 2.4;
        ctx.globalAlpha = Math.min(1, k * 0.35);
        ctx.drawImage(sprite, d.x - hs / 2, d.y - hs / 2, hs, hs);
        ctx.globalAlpha = Math.min(1, k * 1.15);
        ctx.drawImage(sprite, d.x - sz / 2, d.y - sz / 2, sz, sz);
      }
    };
    const frame = (time) => {
      raf = 0;
      if (!visible || document.hidden) return;
      if (lastT && lowPower && time - lastT < 32) { raf = requestAnimationFrame(frame); return; }
      const dt = lastT ? Math.min(64, time - lastT) / 16.67 : 1;
      lastT = time;
      draw(time, dt);
      if (!reduceMotion) raf = requestAnimationFrame(frame);
    };
    const start = () => { if (!raf && visible) { lastT = 0; raf = requestAnimationFrame(frame); } };
    layout();
    new IntersectionObserver((es) => { visible = es[0].isIntersecting; start(); }, { rootMargin: '100px' }).observe(box);
    new ResizeObserver(() => { layout(); if (reduceMotion) { lastT = 0; start(); } }).observe(box);
    document.addEventListener('visibilitychange', start);
  };
  const scan = (root) => (root || document).querySelectorAll('[data-csl-leds-box]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
